import { api } from "@/lib/api";

export interface InlineUpload {
	url: string;
	file_name: string;
	mime_type: string;
	file_size: number;
}

function readFileAsDataUrl(file: File): Promise<string> {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.onload = () => {
			if (typeof reader.result === "string") resolve(reader.result);
			else reject(new Error("Failed to read file."));
		};
		reader.onerror = () => reject(new Error("Failed to read file."));
		reader.readAsDataURL(file);
	});
}

export async function uploadInlineFile(file: File): Promise<InlineUpload> {
	const res = await api.post<{ success: boolean; data: InlineUpload }>(
		"/uploads",
		{
			data: await readFileAsDataUrl(file),
			content_type: file.type,
			file_name: file.name,
		},
	);
	return res.data;
}
